import { useMemo, MutableRefObject } from 'react';
import { GridColDef, GridFilterItem } from '@mui/x-data-grid-premium';
import { uniqueId } from 'lodash';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { orderLineService } from '../api/order-line.service';
import { OrderDetailColumns } from '../order-detail';

type OrderLinesStatusGridProps = {
  statusFilter: string;
  orderRef?: string | null;
  refresh?: MutableRefObject<() => void>;
};

export function OrderLinesStatusGrid({
  statusFilter,
  orderRef,
  refresh
}: OrderLinesStatusGridProps) {
  const columns: GridColDef[] = OrderDetailColumns();

  const { initialFilterItems, initialParams } = useMemo(() => {
    const filters: GridFilterItem[] = [
      {
        id: uniqueId(),
        field: 'status',
        operator: 'is',
        value: statusFilter
      }
    ];
    const params: Record<string, string> = {
      status: statusFilter,
      is_periodic: 'false'
    };

    if (orderRef) {
      filters.push({
        id: uniqueId(),
        field: 'ref',
        operator: 'equals',
        value: orderRef
      });
      params.ref = orderRef;
    }

    return { initialFilterItems: filters, initialParams: params };
  }, [statusFilter, orderRef]);

  return (
    <EnhancedDataGrid
      columns={columns}
      service={orderLineService}
      initialFilterItems={initialFilterItems}
      initialParams={initialParams}
      refresh={refresh}
    />
  );
}

export default OrderLinesStatusGrid;
